var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},_vm._l((_vm.history),function(keyword){return _c('div',{key:keyword,staticClass:"ui label pointer",on:{"click":function($event){_vm.$emit('historyLabelClicked', keyword)}}},[_vm._v(_vm._s(keyword))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dfceba82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/timetable/History.vue
// module id = dk8/
// module chunks = 1